import controller from './form-select.controller';
import template from './form-select.html';

export default {
	controller,
	template,
};
